import secureLocalStorage from "react-secure-storage";
import configureStore from "../store/store";
import { setLogOut } from "../store/actions/loginActions";
//import { customNotify } from "../components/UI/ToastNotify";
import { UIMessage } from "../components/UI/UIMessage";

export const autoLogout = () => {
  const { store } = configureStore();
  // store.dispatch(setLogOut());
  // localStorage.setItem("logout-event", Date.now().toString());
  // localStorage.clear();
  // sessionStorage.clear();
  // secureLocalStorage.clear();
  // customNotify({
  //   message: "Session expired. Please re-login again",
  //   description: "",
  //   type: "warning",
  //   onClose: () => {
  //     window.location.replace("/home");
  //   },
  // });
  UIMessage({
    messageText: "Looks like it's been a while since you signed in. Please log in to continue enjoying a seamless experience.",
    btnText: "Login again",
    onClose: () => {
      store.dispatch(setLogOut());
      localStorage.setItem("logout-event", Date.now().toString());
      localStorage.clear();
      sessionStorage.clear();
      secureLocalStorage.clear();
      window.location.replace(process.env.BASE_NAME + "home");
    },
    closeIcon: false,
  });
};
